import React from 'react'
import { yupResolver } from '@hookform/resolvers'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { smTitle } from '@ifca-root/react-component/src/global/TitleVariable'
import { Grid, TextField, useMediaQuery, useTheme } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { useContext, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import * as yup from 'yup'
// import { ProcurementExitConfirmationDialog } from '../../../components/Dialog/ExitConfirmationDialog';
// import { GPCodeDropdownFullWidth } from '../../../components/Dropdown/GPCodeDropdown';
import {
  useCreateGeneralLedgerPolicyMutation,
  useGetGeneralLedgerPolicyQuery,
  useUpdateGeneralLedgerPolicyMutation,
} from '@account-root/account-react/src/generated/graphql'
import { AcctPermission } from '../../../generated/graphql'
import { SystemMsgs } from '../../../helpers/Messages/SystemMsg'
import { AccCodeDropdownFullWidth } from 'components/Dropdown/AccCodeDropdown'
interface GeneralLedgerPolicyProps {
  GeneralLedgerPolicyID: any
  IsUsedStatistic: boolean
}

export const GeneralLedgerPolicyForm = () => {
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const theme = useTheme()
  const isGLSubscribe = JSON.parse(localStorage.getItem('isGLSubscribe'))
  const [openExitConf, setOpenExitConf] = useState(null)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  // Desktop Checking
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  ////////////////QUERY////////////////
  const {
    error,
    loading,
    data: { getGeneralLedgerPolicy } = { getGeneralLedgerPolicy: [] },
  } = useGetGeneralLedgerPolicyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getGeneralLedgerPolicy }) => {},
  })

  const IsUsedStatisticOption = [
    { Name: 'No', value: false },
    { Name: 'Yes', value: true },
  ]

  //////////// USE FORM ////////////

  const GeneralLedgerPolicySchema = yup.object().shape({
    // IsUsedStatistic: yup
    //   .boolean()
    //   .when('IsUsedStatistic', {
    //     is: true,
    //     then: yup.string().required('GRN Unit Price Policy is required'),
    //     otherwise: null,
    //   })
    //   .nullable(false),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    watch,
    reset,
    setError,
    getValues,
    clearErrors,
    formState: { isDirty },
  } = useForm<GeneralLedgerPolicyProps>({
    mode: 'onSubmit',
    // resolver: yupResolver(GeneralLedgerPolicySchema),
  })

  const editData: any = getGeneralLedgerPolicy[0]

  ////////////////MUTATION////////////////

  const [
    createGeneralLedgerPolicy,
    { loading: createLoading, error: createError },
  ] = useCreateGeneralLedgerPolicyMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        history.push({
          pathname: `/general-ledger/general-setting`,
          state: { success: true, msgMode: 'create' },
        })
      }, 500)
    },
  })

  const [
    updateGeneralLedgerPolicyMutation,
    { loading: updateLoading },
  ] = useUpdateGeneralLedgerPolicyMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setTimeout(() => {
        history.push({
          pathname: `/general-ledger/general-setting`,
          state: { success: true, msgMode: 'create' },
        })
      }, 500)
    },
  })

  const onSubmit = data => {
    if (getGeneralLedgerPolicy?.length < 1) {
      createGeneralLedgerPolicy({
        variables: {
          input: {
            GeneralLedgerPolicyID:
              getGeneralLedgerPolicy[0]?.GeneralLedgerPolicyID,
            IsUsedStatistic: data?.IsUsedStatistic,
          },
        },
      })
    } else {
      updateGeneralLedgerPolicyMutation({
        variables: {
          input: {
            GeneralLedgerPolicyID:
              getGeneralLedgerPolicy[0]?.GeneralLedgerPolicyID,
            IsUsedStatistic: data?.IsUsedStatistic,
          },
        },
      })
    }
  }

  const { handlePermDisabled } = usePermissionChecker()

  return (
    <>
      {loading && <Loading />}
      {createLoading && <Loading />}
      {updateLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          isDirty
            ? setOpenExitConf(true)
            : history.push({
                pathname: `/general-ledger/general-setting/`,
              })
        }}
        title={user?.accountName}
        smTitle={smTitle.GENERAL_LEDGER}
        routeSegments={[
          { name: 'Menu' },
          { name: 'General Ledger Policy', current: true },
        ]}
      />

      <ContentWrapper footer>
        <CardContents>
          <Grid container>
            {/* Used Statistic Account Type Policy */}
            <Grid
              xs={6}
              item
              style={{ textAlign: 'left', alignContent: 'center' }}
              className="xsTitle"
            >
              Used Statistic Account Type
            </Grid>
            <Grid xs={6} item>
              {!loading && (
                <Controller
                  render={({ value, onChange }) => {
                    const editGRN = IsUsedStatisticOption?.filter(
                      pr =>
                        pr?.value ===
                        (getGeneralLedgerPolicy[0]?.IsUsedStatistic ??
                          watch('IsUsedStatistic'))
                    )[0]
                    const selectedPR = IsUsedStatisticOption?.filter(
                      pr => pr?.value === value
                    )[0]

                    return (
                      <Autocomplete
                        fullWidth
                        defaultValue={editGRN}
                        // value={watch('IsUsedStatistic')}
                        options={IsUsedStatisticOption}
                        getOptionLabel={option => {
                          return `${option?.Name}`
                        }}
                        onChange={(value, newValue: any) => {
                          onChange(newValue?.value)
                        }}
                        PopperComponent={AccCodeDropdownFullWidth}
                        renderOption={props => {
                          return (
                            <div>
                              <div className="xsTitle">{props?.Name}</div>
                            </div>
                          )
                        }}
                        renderInput={(params: any) => {
                          return (
                            <div>
                              <TextField
                                {...params}
                                margin="dense"
                                variant="standard"
                                value={
                                  selectedPR ? `${selectedPR?.Name}` : null
                                }
                                defaultValue={
                                  editGRN ? `${editGRN?.Name}` : null
                                }
                                style={{ width: '100%' }}
                                InputLabelProps={
                                  selectedPR ? { shrink: true } : null
                                }
                              />
                            </div>
                          )
                        }}
                      />
                    )
                  }}
                  required
                  fullWidth
                  ref={register}
                  margin="dense"
                  name="IsUsedStatistic"
                  multiline={true}
                  autoComplete="off"
                  control={control}
                  helperText={errors?.IsUsedStatistic?.message}
                  error={errors?.IsUsedStatistic ? true : false}
                  defaultValue={editData?.IsUsedStatistic ?? false}
                />
              )}
            </Grid>
          </Grid>
        </CardContents>
      </ContentWrapper>

      <Footer
        options={[
          {
            name: 'Save',
            onClick: handleSubmit(data => onSubmit(data)),
            disabled:
              // (!user?.superUser &&
              //   handlePermDisabled({
              //     permEnum:
              //       AcctPermission.GeneralLedgerGeneralSettingsGeneralLedgerPolicyCreate,
              //   })) ||
              // (!user?.superUser &&
              //   handlePermDisabled({
              //     permEnum:
              //       AcctPermission.GeneralLedgerGeneralSettingsGeneralLedgerPolicyUpdate,
              //   })),
              !user?.superUser &&
              handlePermDisabled({
                permEnum:
                  AcctPermission.GeneralLedgerGeneralSettingsGeneralLedgerPolicyUpdate,
              }),
            color: 'primary',
          },
        ]}
      />
      {/* <ProcurementExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/general-ledger/general-setting`);
        }}
      /> */}
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
